import { factoryService, getJsonRequest } from '@chilecompra/react-kit/requests'
import { REACT_APP_ATTACHMENT_API_URL } from '../config/settings/environment'

/**
 * Gets the pre-signed URL to download an object (attachment)
 */
export const getFileFromBucket = factoryService(({ iddoc }) =>
  getJsonRequest(`${REACT_APP_ATTACHMENT_API_URL}/adjuntos-get-api/${iddoc}`, {
    retries: 2
  })
)
